import React, { useState } from 'react';
import { Play, Clock, Eye, TrendingUp, Share2, Bookmark, ChevronRight, Search, Filter } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

function Politics() {
  const [selectedFilter, setSelectedFilter] = useState('सभी');
  const navigate = useNavigate();

  // Demo data - Replace with actual API data
  const mainStory = {
    id: 1,
    title: 'संसद का बजट सत्र: विपक्ष का हंगामा, सरकार पर निशाना',
    subtitle: 'लोकसभा में हुई तीखी बहस, कई मुद्दों पर टकराव',
    image: 'https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=800&q=80',
    category: 'लोकसभा',
    views: '2.3M',
    timeAgo: '2 घंटे पहले',
    isVideo: false
  };

  const topStories = [
    {
      id: 2,
      title: 'चुनाव आयोग का बड़ा फैसला: 5 राज्यों में विधानसभा चुनाव की तारीखें घोषित',
      image: 'https://images.unsplash.com/photo-1595666944516-bbb485958fb5?w=500&q=80',
      category: 'चुनाव',
      views: '1.8M',
      timeAgo: '4 घंटे पहले',
      isVideo: true
    },
    {
      id: 3,
      title: 'प्रधानमंत्री की अमेरिका यात्रा: द्विपक्षीय वार्ता में बड़ी सफलता',
      image: 'https://images.unsplash.com/photo-1555421689-d68471e189f2?w=500&q=80',
      category: 'विदेश नीति',
      views: '1.5M',
      timeAgo: '6 घंटे पहले',
      isVideo: false
    },
    {
      id: 4,
      title: 'राज्यसभा में पारित हुआ महत्वपूर्ण विधेयक, विपक्ष का बहिर्गमन',
      image: 'https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=500&q=80',
      category: 'राज्यसभा',
      views: '980K',
      timeAgo: '8 घंटे पहले',
      isVideo: false
    }
  ];

  const latestNews = [
    {
      id: 5,
      title: 'मुख्यमंत्री ने किया विकास योजनाओं का शुभारंभ, 5000 करोड़ का बजट',
      image: 'https://images.unsplash.com/photo-1541872703-74c5e44368f9?w=400&q=80',
      category: 'राज्य राजनीति',
      views: '750K',
      timeAgo: '3 घंटे पहले'
    },
    {
      id: 6,
      title: 'भ्रष्टाचार के आरोप: CBI ने दर्ज की FIR, छापेमारी जारी',
      image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400&q=80',
      category: 'जांच',
      views: '1.2M',
      timeAgo: '5 घंटे पहले'
    },
    {
      id: 7,
      title: 'सुप्रीम कोर्ट का ऐतिहासिक फैसला, संविधान की व्याख्या पर बहस',
      image: 'https://images.unsplash.com/photo-1589391886645-d51941baf7fb?w=400&q=80',
      category: 'न्यायपालिका',
      views: '890K',
      timeAgo: '7 घंटे पहले'
    },
    {
      id: 8,
      title: 'पार्टी अध्यक्ष चुनाव में बड़ा उलटफेर, किसे मिलेगा समर्थन?',
      image: 'https://images.unsplash.com/photo-1611003228941-98852ba62227?w=400&q=80',
      category: 'पार्टी राजनीति',
      views: '650K',
      timeAgo: '9 घंटे पहले'
    },
    {
      id: 9,
      title: 'किसान आंदोलन: नई बैठक की तारीख तय, सरकार ने बुलाई वार्ता',
      image: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=400&q=80',
      category: 'आंदोलन',
      views: '1.1M',
      timeAgo: '10 घंटे पहले'
    },
    {
      id: 10,
      title: 'राज्यपाल ने विधानसभा सत्र बुलाया, कई विधेयक होंगे पेश',
      image: 'https://images.unsplash.com/photo-1577563908411-5077b6dc7624?w=400&q=80',
      category: 'विधानसभा',
      views: '520K',
      timeAgo: '12 घंटे पहले'
    }
  ];

  const trendingTopics = [
    'संसद सत्र 2026',
    'विधानसभा चुनाव',
    'बजट प्रस्ताव',
    'विदेश नीति',
    'न्यायिक सुधार',
    'राज्य राजनीति'
  ];

  const filters = ['सभी', 'लोकसभा', 'राज्यसभा', 'चुनाव', 'न्यायपालिका', 'राज्य'];

  // Handler for navigating to full news page
  const handleNewsClick = (newsId) => {
    navigate('/fullnewsread', { state: { newsId } });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200 sticky top-0 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 py-3 sm:py-4">
          <div className="flex items-center gap-2 overflow-x-auto scrollbar-hide">
            {filters.map((filter) => (
              <button
                key={filter}
                onClick={() => setSelectedFilter(filter)}
                className={`px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg font-semibold whitespace-nowrap transition-all text-xs sm:text-sm ${
                  selectedFilter === filter
                    ? 'bg-[#ef0501] text-white shadow-md'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 py-4 sm:py-6 lg:py-8">
        {/* Main Story + Top Stories Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-8 lg:mb-12">
          {/* Main Featured Story */}
          <div className="lg:col-span-2">
            <div 
              onClick={() => handleNewsClick(mainStory.id)}
              className="group relative bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl 
              transition-all duration-500 cursor-pointer h-full"
            >
              <div className="relative overflow-hidden h-64 sm:h-80 lg:h-96">
                <img
                  src={mainStory.image}
                  alt={mainStory.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent"></div>
                
                {/* Badge */}
                <div className="absolute top-4 left-4">
                  <span className="bg-[#ef0501] text-white px-3 py-1.5 rounded text-xs font-bold 
                    uppercase tracking-wide shadow-lg flex items-center gap-1.5">
                    <TrendingUp className="w-3.5 h-3.5" />
                    मुख्य खबर
                  </span>
                </div>

                {/* Category */}
                <div className="absolute top-4 right-4">
                  <span className="bg-white text-gray-900 px-3 py-1 rounded text-xs font-semibold shadow-lg">
                    {mainStory.category}
                  </span>
                </div>

                {/* Content Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6">
                  <h2 className="text-white text-xl sm:text-2xl md:text-3xl font-bold leading-tight mb-2 
                    drop-shadow-2xl">
                    {mainStory.title}
                  </h2>
                  <p className="text-gray-200 text-sm sm:text-base mb-3 sm:mb-4 line-clamp-2">
                    {mainStory.subtitle}
                  </p>
                  <div className="flex items-center gap-3 sm:gap-4 text-white text-xs sm:text-sm">
                    <span className="flex items-center gap-1.5">
                      <Eye className="w-4 h-4" />
                      {mainStory.views}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <Clock className="w-4 h-4" />
                      {mainStory.timeAgo}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Top Stories Sidebar */}
          <div className="space-y-3 sm:space-y-4">
            {topStories.map((story) => (
              <div
                key={story.id}
                onClick={() => handleNewsClick(story.id)}
                className="group bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg 
                  transition-all duration-300 cursor-pointer"
              >
                <div className="flex gap-3 sm:gap-4">
                  <div className="relative w-28 sm:w-32 flex-shrink-0">
                    <img
                      src={story.image}
                      alt={story.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    {story.isVideo && (
                      <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                        <div className="bg-white rounded-full p-2 shadow-lg">
                          <Play className="w-5 h-5 text-[#ef0501] fill-[#ef0501]" />
                        </div>
                      </div>
                    )}
                    <div className="absolute top-2 left-2">
                      <span className="bg-[#ef0501] text-white px-2 py-0.5 rounded text-xs font-semibold">
                        {story.category}
                      </span>
                    </div>
                  </div>
                  <div className="flex-1 p-3 sm:p-4 pr-2">
                    <h3 className="text-gray-900 text-xs sm:text-sm font-semibold line-clamp-3 
                      group-hover:text-[#ef0501] transition-colors leading-snug mb-2">
                      {story.title}
                    </h3>
                    <div className="flex items-center gap-2 text-gray-500 text-xs">
                      <span className="flex items-center gap-1">
                        <Eye className="w-3 h-3" />
                        {story.views}
                      </span>
                      <span className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        {story.timeAgo}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Trending Topics */}
        <div className="bg-white rounded-lg p-4 sm:p-6 mb-6 sm:mb-8 shadow-md border border-gray-200">
          <h3 className="text-gray-900 text-lg sm:text-xl font-bold mb-3 sm:mb-4 flex items-center gap-2">
            <TrendingUp className="w-5 h-5 sm:w-6 sm:h-6 text-[#ef0501]" />
            ट्रेंडिंग विषय
          </h3>
          <div className="flex flex-wrap gap-2 sm:gap-3">
            {trendingTopics.map((topic, index) => (
              <button
                key={index}
                className="bg-gray-100 hover:bg-[#ef0501] text-gray-800 hover:text-white px-3 sm:px-4 
                  py-2 rounded-lg text-xs sm:text-sm font-semibold hover:shadow-md transition-all"
              >
                #{topic}
              </button>
            ))}
          </div>
        </div>

        {/* Latest News Grid */}
        <div>
          <div className="flex items-center justify-between mb-4 sm:mb-6">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 flex items-center gap-2 sm:gap-3">
              <span className="w-1.5 h-8 sm:h-10 bg-[#ef0501] rounded"></span>
              ताज़ा खबरें
            </h2>
            <button className="text-[#ef0501] hover:text-red-700 font-semibold text-sm sm:text-base 
              flex items-center gap-1 transition-colors">
              सभी देखें
              <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
            </button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {latestNews.map((news) => (
              <div
                key={news.id}
                onClick={() => handleNewsClick(news.id)}
                className="group bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl 
                  transition-all duration-500 cursor-pointer hover:-translate-y-1"
              >
                <div className="relative overflow-hidden h-44 sm:h-48">
                  <img
                    src={news.image}
                    alt={news.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  
                  <div className="absolute top-3 left-3">
                    <span className="bg-[#ef0501] text-white px-2 sm:px-3 py-1 rounded text-xs 
                      font-semibold shadow-lg">
                      {news.category}
                    </span>
                  </div>

                  <div className="absolute bottom-3 right-3 flex gap-2">
                    <button 
                      onClick={(e) => {
                        e.stopPropagation();
                        // Share functionality
                      }}
                      className="bg-white/90 backdrop-blur-sm p-2 rounded-lg hover:bg-white 
                      transition-all shadow-md"
                    >
                      <Share2 className="w-3.5 h-3.5 text-gray-700" />
                    </button>
                    <button 
                      onClick={(e) => {
                        e.stopPropagation();
                        // Bookmark functionality
                      }}
                      className="bg-white/90 backdrop-blur-sm p-2 rounded-lg hover:bg-white 
                      transition-all shadow-md"
                    >
                      <Bookmark className="w-3.5 h-3.5 text-gray-700" />
                    </button>
                  </div>
                </div>

                <div className="p-4">
                  <h3 className="text-gray-900 text-sm sm:text-base font-semibold line-clamp-3 mb-3 
                    group-hover:text-[#ef0501] transition-colors leading-snug">
                    {news.title}
                  </h3>
                  <div className="flex items-center justify-between text-gray-500 text-xs">
                    <span className="flex items-center gap-1">
                      <Eye className="w-3.5 h-3.5" />
                      {news.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <Clock className="w-3.5 h-3.5" />
                      {news.timeAgo}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Load More Button */}
        <div className="text-center mt-8 sm:mt-12">
          <button className="bg-[#ef0501] hover:bg-red-700 text-white px-6 sm:px-8 py-3 sm:py-4 
            rounded-lg font-semibold text-sm sm:text-base shadow-lg hover:shadow-xl transition-all">
            और खबरें लोड करें
          </button>
        </div>
      </main>

      {/* Scroll to Top Button */}
      <button 
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-6 right-6 bg-[#ef0501] text-white p-3 sm:p-4 rounded-full 
        shadow-xl hover:shadow-2xl transition-all hover:scale-110 z-50"
      >
        <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6 rotate-[-90deg]" />
      </button>

      <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
}

export default Politics;